import { registerKlipyProvider } from '@/services/media/providers/klipy';

registerKlipyProvider();
